import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // For navigation
import { FaChevronLeft, FaChevronRight, FaSignOutAlt } from "react-icons/fa";
import "./Sidebar.css";
import userIcon from "../assets/icons/user.svg"; // Replace with actual path
import voucherIcon from "../assets/icons/voucher.svg"; // Replace with actual path
import logo from "../assets/logo.png"; // Company/Brand logo

function Sidebar({ onSelect }) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();

  // Logout Function
  const handleLogout = () => {
    localStorage.removeItem("token"); // Remove authentication token
    localStorage.removeItem("admin_id"); // Remove admin_id
    localStorage.removeItem("permissions");
    alert("Logged out successfully!");
    navigate("/user"); // Redirect to admin login
  };

  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      {/* Sidebar Logo */}
      <div className="sidebar-logo">
        <img src={logo} alt="Company Logo" />
      </div>

      <button className="toggle-btn" onClick={() => setIsCollapsed(!isCollapsed)}>
        {isCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
      </button>

      <ul>
        <li onClick={() => onSelect("inventory")}>
          <img src={userIcon} alt="Inventory Icon" className="sidebar-icon" />
          {!isCollapsed && "inventory"}
        </li>
        <li onClick={() => onSelect("users")}>
          <img src={userIcon} alt="User Icon" className="sidebar-icon" />
          {!isCollapsed && "Users"}
        </li>
        <li onClick={() => onSelect("Locations")}>
          <img src={voucherIcon} alt="Voucher Icon" className="sidebar-icon" />
          {!isCollapsed && "Locations"}
        </li>  
        <li onClick={() => onSelect("Stocktake")}>
          <img src={voucherIcon} alt="Voucher Icon" className="sidebar-icon" />
          {!isCollapsed && "Stocktake"}
        </li>  
        <li onClick={() => onSelect("Department")}>
          <img src={voucherIcon} alt="Voucher Icon" className="sidebar-icon" />
          {!isCollapsed && "Department"}
        </li>  
        <li onClick={() => onSelect("AccessRole")}>
          <img src={voucherIcon} alt="Voucher Icon" className="sidebar-icon" />
          {!isCollapsed && "AccessRole"}
        </li>                         
        
      </ul>

      {/* Logout Button */}
      <button className="logout-btn" onClick={handleLogout}>
        <FaSignOutAlt className="logout-icon" />
        {!isCollapsed && <span>Logout</span>}
      </button>
    </div>
  );
}

export default Sidebar;
